import { SET_ACCESS_TOKEN, RESET_TOKEN } from "./AccountActionTypes";

const actions = {
	[SET_ACCESS_TOKEN]: ({ commit }, token) =>
	{
		commit(SET_ACCESS_TOKEN, token);
	},
	[RESET_TOKEN]: ({ commit }) =>
	{
		commit(RESET_TOKEN);
	},
};

export default { actions };
